import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["name", "className", "children", "title", "message", "actionElement"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.function.name.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
var achievement = require('@govhhs/govhhs-design-system-core/dist/img/illustrations/achievement.svg');
var clearDay = require('@govhhs/govhhs-design-system-core/dist/img/illustrations/clear-day.svg');
var noInternet = require('@govhhs/govhhs-design-system-core/dist/img/illustrations/no-internet-connection.svg');
var pageNotFound = require('@govhhs/govhhs-design-system-core/dist/img/illustrations/404.svg');
var brokenPage = require('@govhhs/govhhs-design-system-core/dist/img/illustrations/broken-page.svg');
var propTypes = {
  className: PropTypes.string,
  /**
  the name of pre-defined illustration,
  it should be one of ['achievement', 'clearDay', 'noInternet', 'brokenPage', 'pageNotFound'].
  */
  name: PropTypes.oneOf(['achievement', 'clearDay', 'noInternet', 'brokenPage', 'pageNotFound']),
  /**
  other type of illustration such as iconSet is passed as a child node
  */
  children: PropTypes.node,
  /**
  the title of illustration - rendered inside an h4 element
  */
  title: PropTypes.node,
  /**
  the message of illustration - rendered inside a p element
  */
  message: PropTypes.node,
  /**
   action element (Button or Link), that appears after the message on a new line
  */
  actionElement: PropTypes.node
};
var defaultProps = {
  className: undefined,
  name: undefined,
  children: undefined,
  title: undefined,
  message: undefined,
  actionElement: undefined
};
var src = function src(name) {
  switch (name) {
    case 'achievement':
      return achievement;
    case 'clearDay':
      return clearDay;
    case 'noInternet':
      return noInternet;
    case 'pageNotFound':
      return pageNotFound;
    case 'brokenPage':
      return brokenPage;
    default:
      console.error('IllustratedMessage name must be one of [achievement, clearDay, noInternet]');
      return '';
  }
};
var maxWidth = {
  maxWidth: 320
};
var IllustratedMessage = function IllustratedMessage(_ref) {
  var name = _ref.name,
    className = _ref.className,
    children = _ref.children,
    title = _ref.title,
    message = _ref.message,
    actionElement = _ref.actionElement,
    other = _objectWithoutProperties(_ref, _excluded);
  var styleClassName = classNames('wds-u-align--center wds-u-type--meta', className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: styleClassName
  }, other), name && /*#__PURE__*/React.createElement("div", {
    className: "wds-u-m--auto",
    style: maxWidth
  }, /*#__PURE__*/React.createElement("img", {
    src: src(name),
    alt: name
  })), children && children, title && /*#__PURE__*/React.createElement("h4", null, title), message && /*#__PURE__*/React.createElement("p", null, message), actionElement && actionElement);
};
IllustratedMessage.propTypes = propTypes;
IllustratedMessage.defaultProps = defaultProps;
export default IllustratedMessage;